import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

import { SnackbarContext } from '../../../layout/SnackbarContext';
import { EditCodebacks } from './EditCodebacks';
import { ReviewCodebacks } from './ReviewCodebacks';

export const CodebackDrawer = ({
  isOpen,
  setIsOpen,
  applicationId,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  applicationId: string;
}) => {
  const [mibCodes, setMibCodes] = useState([] as string[]);
  const [isReview, setIsReview] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setMibCodes([] as string[]);
    }
  }, [isOpen]);

  // XHR error handling
  const { openSnacks, setSnacks } = useContext(SnackbarContext);
  const updateSnacks = (updatedSnacks: any) => {
    setSnacks(updatedSnacks);
  };

  return (
    <>
      {isReview && (
        <ReviewCodebacks
          applicationId={applicationId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setIsReview={setIsReview}
          mibCodes={mibCodes}
          openSnacks={openSnacks}
          updateSnacks={updateSnacks}
        />
      )}
      {!isReview && (
        <EditCodebacks
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setIsReview={setIsReview}
          mibCodes={mibCodes}
          setMibCodes={setMibCodes}
        />
      )}
    </>
  );
};
